export default __webpack_public_path__ + "static/media/react.ba0dc43e.png";